import React from "react";

const CanvaIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2773_1270)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "#7D2AE7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "url(#paint0_radial_2773_1270)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "url(#paint1_radial_2773_1270)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "url(#paint2_radial_2773_1270)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "url(#paint3_radial_2773_1270)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.6346 24.1027C28.4695 24.1027 28.3242 24.2421 28.1731 24.5465C26.4661 28.0078 23.5179 30.4568 20.1063 30.4568C16.1614 30.4568 13.7185 26.8958 13.7185 21.9762C13.7185 13.6429 18.3616 8.8247 22.4398 8.8247C24.3455 8.8247 25.5093 10.0223 25.5093 11.9281C25.5093 14.1899 24.2242 15.3875 24.2242 16.1852C24.2242 16.5433 24.447 16.7601 24.8887 16.7601C26.6632 16.7601 28.7459 14.7211 28.7459 11.8405C28.7459 9.0475 26.315 6.99451 22.2369 6.99451C15.497 6.99451 9.50708 13.243 9.50708 21.8886C9.50708 28.5808 13.3286 33.0032 19.225 33.0032C25.4834 33.0032 29.1021 26.7764 29.1021 24.7554C29.1021 24.3078 28.8733 24.1027 28.6346 24.1027Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_2773_1270",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(7.7265 35.4529) rotate(-49.416) scale(30.9366)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6420FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6420FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_2773_1270",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.5894 4.54728) rotate(54.703) scale(34.8867)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00C4CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00C4CC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_2773_1270",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(7.72632 35.4526) rotate(-45.1954) scale(30.5621 14.0559)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6420FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6420FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_2773_1270",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.3579 5.38947) rotate(66.5198) scale(31.4918 52.7558)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00C4CC",
  stopOpacity: 0.725916
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopColor: "#00C4CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00C4CC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2773_1270"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CanvaIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;